import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Component_Products from "../components/Component_Products";
import Footer from "../components/Footer";
import PRODUCTS from "../data/productsData";
import { PRODUCT_CARDS } from "../pages/Products";

export default function ProductDetails() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const product = PRODUCTS[slug];

  const cleanProduct = PRODUCT_CARDS.find(
    (p) => p.slug === slug
  );

  const displayTitle = cleanProduct
    ? cleanProduct.title
    : product?.title;

  const [selectedSize, setSelectedSize] = useState("S");
  const [qty, setQty] = useState(1);
  const [imgIndex, setImgIndex] = useState(0);
  const [selectedColor, setSelectedColor] = useState(
    product?.colors ? product.colors[0] : null
  );

  /* ================= FAKE DESKTOP DETECTION ================= */
  const [isFakeDesktop, setIsFakeDesktop] = useState(false);

  useEffect(() => {
    const check = () => {
      if (typeof window !== "undefined") {
        const fake =
          window.screen.width < 900 &&
          window.innerWidth >= 900;
        setIsFakeDesktop(fake);
      }
    };

    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);
  /* ========================================================= */

  if (!product) return <div>Product Not Found</div>;

  const nextImage = () => {
    setImgIndex((prev) => (prev + 1) % product.images.length);
  };

  const prevImage = () => {
    setImgIndex(
      (prev) => (prev - 1 + product.images.length) % product.images.length
    );
  };

  const isLightColor = (color) => {
    if (!color) return false;
    const c = color.toLowerCase();
    return c === "#ffffff" || c === "white" || c === "#fff";
  };

  return (
    <main className="bg-[#f4f4f4] min-h-screen">
      <Navbar />

      {/* BREADCRUMB */}
      <div
        className="w-full bg-cover bg-center"
        style={{ backgroundImage: "url('/Breadcrumb.png')" }}
      >
        <div className="bg-black/50 w-full">
          <div className="max-w-6xl mx-auto px-6 py-5 text-white text-sm md:text-base">
            <span
              onClick={() => navigate("/")}
              className="cursor-pointer hover:text-orange-400 transition"
            >
              Home
            </span>

            <span className="mx-2 text-gray-300">/</span>

            <span
              onClick={() => navigate("/products")}
              className="cursor-pointer hover:text-orange-400 transition"
            >
              All Products
            </span>

            <span className="mx-2 text-gray-300">/</span>

            <span className="text-orange-400">
              {displayTitle}
            </span>
          </div>
        </div>
      </div>

      {/* PRODUCT SECTION */}
      <div className="max-w-6xl mx-auto mt-[4vh] pb-12 px-6 flex flex-col lg:flex-row gap-3 lg:gap-12">

        {/* LEFT */}
        <div className="w-full lg:w-1/2 flex flex-col items-center">
          <div className="relative w-full">
            <img
              src={product.images[imgIndex]}
              alt="product"
              className="w-full h-[520px] md:h-[580px] object-contain"
            />

            {/* LEFT ARROW */}
            <button
              onClick={prevImage}
              className={`absolute top-1/2 -translate-y-1/2 
              ${isFakeDesktop ? "left-56" : "left-0"}
              w-12 h-12 bg-black/70 text-white text-xl
              hover:bg-orange-500 transition flex items-center justify-center`}
            >
              ←
            </button>

            {/* RIGHT ARROW */}
            <button
              onClick={nextImage}
              className={`absolute top-1/2 -translate-y-1/2 
              ${isFakeDesktop ? "right-56" : "right-0"}
              w-12 h-12 bg-black/70 text-white text-xl
              hover:bg-orange-500 transition flex items-center justify-center`}
            >
              →
            </button>
          </div>

          <div className="flex gap-2 mt-2 justify-center">
            {product.images.map((_, i) => (
              <div
                key={i}
                className={`w-2 h-2 rounded-full ${
                  imgIndex === i ? "bg-orange-500" : "bg-gray-300"
                }`}
              />
            ))}
          </div>
        </div>

        {/* RIGHT */}
        <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left">
          <span className="bg-gray-200 text-xs px-3 py-1 rounded-full">
            {product.tag}
          </span>

          <h1 className="text-3xl mt-3 font-semibold">
            {displayTitle}
          </h1>

          <p className="mt-6 text-sm text-gray-600">Size</p>

          <div className="flex gap-2 mt-2 justify-center lg:justify-start">
            {product.sizes.map((s) => (
              <button
                key={s}
                onClick={() => setSelectedSize(s)}
                className={`border px-3 py-2 text-sm ${
                  selectedSize === s
                    ? "bg-black text-white"
                    : "bg-white"
                }`}
              >
                {s}
              </button>
            ))}
          </div>

          <p className="mt-6 text-sm text-gray-600">Colors</p>

          <div className="grid grid-cols-10 gap-3 mt-3 justify-center lg:justify-start">
            {product.colors.map((color, i) => (
              <div
                key={i}
                onClick={() => setSelectedColor(color)}
                className={`w-8 h-8 rounded-full cursor-pointer ${
                  isLightColor(color)
                    ? "border border-gray-400"
                    : ""
                }`}
                style={{ backgroundColor: color }}
              />
            ))}
          </div>
        </div>
      </div>

      <Component_Products />
      <Footer />
    </main>
  );
}
